
import AnimatedCheckmark from '@marketplace/components/shared/animations/animated-checkmark.vue'
import { CANCEL_RETAILER_ORDER_MUTATION } from '@marketplace/graphql/orders.js'
import { EventBus } from '@marketplace/plugins/event-bus.js'

export default {
    name: 'ModalCancelOrder',

    components: {
        AnimatedCheckmark,
    },

    props: {
        orderId: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            message: '',
            thankyou: false,
            userErrors: '',
            loading: false,
        }
    },

    methods: {
        closeModal() {
            EventBus.$emit('modal-close')
        },
        handleClick() {
            this.loading = true
            this.$apollo
                .mutate({
                    mutation: CANCEL_RETAILER_ORDER_MUTATION,
                    variables: {
                        retailerOrderId: this.orderId,
                    },
                })
                .then((res) => {
                    this.userErrors = ''

                    if (res.data.retailerOrderCancel?.success === false) {
                        this.userErrors = res.data.retailerOrderCancel.message
                        setTimeout(() => {
                            this.closeModal()
                        }, 2500)
                        return false
                    }
                    this.thankyou = true
                    setTimeout(() => {
                        this.closeModal()
                        window.location.reload()
                    }, 2000)
                })
                .finally(() => {
                    this.loading = false
                })
        },
    },
}
